// extracted by mini-css-extract-plugin
module.exports = {"templateSelectBtn":"SelectBookType_templateSelectBtn__33GmU"};